export default __webpack_public_path__ + "static/media/arrow.bb254738.svg";